import React from 'react'
import MaterialSymbol from '../material-symbol'

const AccessTime = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="access_time" {...props} />
))

AccessTime.displayName = 'AccessTime'

export default AccessTime
